var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 17",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.135 9.093c-.612 0-1.11.5-1.11 1.115v4.562H2.22v-4.562c0-.615-.498-1.115-1.11-1.115-.613 0-1.111.5-1.111 1.115v5.248C0 16.308.69 17 1.538 17h18.17c.849 0 1.538-.692 1.538-1.544v-5.248c0-.615-.498-1.115-1.11-1.115Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.905 6.126a1.114 1.114 0 0 0 1.557-.224l1.046-1.41v7.343c0 .615.498 1.114 1.11 1.114.614 0 1.111-.5 1.111-1.114v-7.35l1.047 1.41a1.108 1.108 0 0 0 1.557.225c.492-.365.594-1.07.224-1.564L11.506.45a1.107 1.107 0 0 0-1.78 0L6.674 4.556a1.13 1.13 0 0 0 .23 1.57Z"
  })));
};

export default SvgUpload;